import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import FooterShade from "../partials/footer";
//import ShareButtons from "../components/sharebuttons";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';

import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare
}
from '@fortawesome/free-brands-svg-icons'
import {
  faTwitterSquare
}
  from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

const cookies = new Cookies();

class Notikums extends Component {
  render() {
        const {
      data: { loading, errors, notikumi }
    } = this.props;

    if (!this.props.data.notikums) {
      return <p>...</p>;
    }
    const images = this.props.data.notikums.galerija.gallery.map((prop, i) => {
      //console.log(prop.sourceUrl);
      return (

        <Carousel.Item
          key={
            i
          }
          style={
            {
              backgroundImage: `url(${prop.sourceUrl})`
            }
          } >

            <div className="carousel-item-herotextnarrow-wrap">
              <div className = "herotext herotext__morebottom" > {
                cookies.get("lang") === "LV" && this.props.data.notikums.title
              }
              {cookies.get("lang") === "EN" &&
                this.props.data.notikums.translation.title}</div>
            </div>
          <FooterShade />
        </Carousel.Item>
      );
    });

    //console.log(CarouselIndicators);
    return (
      <React.Fragment>
        <div id = "singleNotikums"
        data-headertitle = {
          cookies.get("lang") === "LV" ? "< Notikumi" : cookies.get("lang") === "EN" ? "< Events" : null
        } >
        <Carousel
          id="carouselId" className="narrow-carousel"  controls={false} fade={true} interval={6000} pause={false}
        >
          {images}

        </Carousel>
        <div className="container single-content-text">
          {/* <header className="single-header">
            <h2 className="entry-title">
              {cookies.get("lang") === "LV" && props.data.notikums.title}
              {cookies.get("lang") === "EN" &&
                props.data.notikums.translation.title}
            </h2>
            <div className="single-share-btns">
              <span>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsText}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsTextEn}
              </span>
              <ShareButtons />
            </div>
          </header> */}
        {this.props.data.notikums.content && (
          <div className="row justify-content-center ">
          <div className="col-12 col-md-8 mt-5 telpasDescrWrap">
            <h2>{cookies.get("lang") === "LV" &&
              this.props.data.notikums.subTitle.subTitle}
            {cookies.get("lang") === "EN" &&
              this.props.data.notikums.translation.subTitle.subTitle}</h2>
            {cookies.get("lang") === "LV" &&
               <p dangerouslySetInnerHTML={{ __html: this.props.data.notikums.content }} />}
            {cookies.get("lang") === "EN" &&
              <p dangerouslySetInnerHTML={{ __html: this.props.data.notikums.translation.content }} />}
          </div>
          </div>
        )}
          <div className="single-share-btns">
              <span>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsText}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsTextEn}
              </span>
              <span>
    <a
      href={'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/notikumi/' + this.props.data.notikums.slug + '&quote=Kaņepes%20Kultūras%20Centrs - '+ this.props.data.notikums.title}
      target="_blank"
      rel="noopener noreferrer"
      title="Share on Facebook"
      className="share-icon"
      onClick={() =>
        "window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faFacebookSquare} />
      <span className="sr-only">Share on Facebook</span>
    </a>
    <a
      href={'https://twitter.com/intent/tweet?source=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/notikumi/' + this.props.data.notikums.slug + '&text=Kaņepes%20Kultūras%20Centrs - '+this.props.data.notikums.title + ' https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/notikumi/' + this.props.data.notikums.slug+'&via=kanepeskc'}
      target="_blank"
      rel="noopener noreferrer"
      title="Tweet"
      className="share-icon"
      onClick={() =>
        "window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ':%20' + encodeURIComponent(document.URL)); return false;"
      }
    >
      <FontAwesomeIcon icon={faTwitterSquare} />
      <span className="sr-only">Tweet</span>
    </a>
    <a
      href={'mailto:?subject=Kaņepes Kultūras centrs - '+this.props.data.notikums.title + '&body=https%3A%2F%2Fkanepes.lv/'+cookies.get("lang").toLowerCase()+'/notikumi/' + this.props.data.notikums.slug}
      target="_blank"
      rel="noopener noreferrer"
      title="Share via E-mail"
      className="share-icon"
    >
      <FontAwesomeIcon icon={faEnvelope} />
      <span className="sr-only">E-mail</span>
    </a>
  </span>
          </div>
          <div className="seperatorTitle">
            <h2>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.citiNotikumiLv}
                {cookies.get("lang") === "EN" &&
                this.props.data.themeGeneralSettings.optionsPage.citiNotikumiEn}
            </h2>
          </div>
        </div>


        <div className="container notikumi-container">
        <div className="row">
          {loading && <div className="loader" />}
          {errors && <div className="errors">...</div>}

          {!loading && !notikumi && (
            <span className="none">Nav notikumu...</span>
          )}

          {!loading &&
            notikumi &&
            notikumi.edges.map((prop, i) => (
              <div className="col-12 col-sm-6 col-md-4 notikumi-single-card" key={i}>
                <div className="galWrap">
                  <div
                    className="notikumi-single-card-wrap"
                    style={{
                      backgroundImage: `url(${prop.node.galerija.gallery[0].sourceUrl})`
                    }}
                  >
            <Link
              to={`/${cookies.get("lang").toLowerCase()}/notikumi/${prop.node.slug}`}
              className="notikumi-single-card-a"
            >
              <div className="notikumi-single-card-a-text">
                {prop.node.title}
              </div>
            </Link>
                  </div>
                </div>
              </div>
            ))}

          {!loading && notikumi && notikumi.pageInfo.hasNextPage === true && (
            <div className="loadMoreWrap mb-5">
              <button onClick={this.onFetchMore}>
                {cookies.get("lang") === "LV" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
                {cookies.get("lang") === "EN" &&
                  this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
              </button>
            </div>
          )}
        </div>
        </div>
        </div>
      </React.Fragment>
      
    );
    
  }
    onFetchMore = () => {
    const {
      data: { notikumi, fetchMore }
    } = this.props;
    //console.log(this.props);

    fetchMore({
      variables: {
        cursor: notikumi.pageInfo.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.notikumi.edges;
        const pageInfo = fetchMoreResult.notikumi.pageInfo;

        return newEdges.length
          ? {
              // Put the new pages at the end of the list and update `pageInfo`
              // so we have the new `endCursor` and `hasNextPage` values
              notikumi: {
                __typename: previousResult.notikumi.__typename,
                edges: [...previousResult.notikumi.edges, ...newEdges],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };
}

const GetNotikumsBySlug = gql`
query Notikums($slug: ID!,$lang: LanguageCodeFilterEnum,$cursor: String) {
  notikums(id: $slug, idType: URI) {
    content(format: RENDERED)
    id
    title
    galerija {
      gallery {
        sourceUrl
      }
    }
    slug
    translation(language: EN) {
      title
      content(format: RENDERED)
      subTitle {
        subTitle
      }
    }
    subTitle {
      subTitle
    }
  }
  themeGeneralSettings {
    optionsPage {
      singlePostShareButtonsText
        gimmeMore
        gimmeMoreEn
        citiNotikumiLv
        citiNotikumiEn
    }
  }
  notikumi(where: {language: $lang, excludeBySlug: $slug },first: 6, after: $cursor) {
      edges {
        node {
          id
          galerija {
            gallery {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
          title
          slug
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
}

`;
    const cookieLang = cookies.get("lang");

export default graphql(GetNotikumsBySlug, {
  options: props => {
    const slug = props.match.params.slug;
  console.log(slug);
    return {
      variables: {
        slug,
        lang: cookieLang
      }
    };
  }
})(Notikums);

